<template>
    <ClientOnly>
        <div class="js-home-slider" :data-component-id="componentId">
            <div class="c-home__slider s-swiper">
                <div class="c-home__banner" v-if="home?.property_label?.value" :class="home.property_label.type">
                    {{ home.property_label.value }}
                </div>

                <swiper-container
                    ref="containerRef"
                    :init="false"
                    :auto-height="false"
                    :pagination-el="`.js-home-slider[data-component-id=${componentId}] .js-swiper-pagination`"
                    :navigation-next-el="`.js-home-slider[data-component-id=${componentId}] .js-swiper-button-next`"
                    :navigation-prev-el="`.js-home-slider[data-component-id=${componentId}] .js-swiper-button-prev`"
                    v-if="slides.length > 0">
                    <swiper-slide v-for="(image, index) in slides" :key="index">
                        <img
                            :src="image"
                            :loading="index >= 4 ? 'lazy' : undefined"
                            :alt="`Image of ${home?.title.rendered}`"
                            :title="home?.title.rendered" />

                        <div v-if="index >= 4" class="swiper-lazy-preloader"></div>
                    </swiper-slide>
                </swiper-container>

                <div v-if="slides.length > 2 && props.navigation" class="swiper-navigation">
                    <button class="swiper-button-prev js-swiper-button-prev" aria-label="Previous slide" type="button">
                        <i class="fa-sharp fa-chevron-left"></i>
                    </button>

                    <button class="swiper-button-next js-swiper-button-next" aria-label="Next slide" type="button">
                        <i class="fa-sharp fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <div class="c-home__slider-controls s-swiper-pagination" v-if="slides.length > 0">
                <div class="swiper-pagination js-swiper-pagination"></div>
            </div>
        </div>
    </ClientOnly>
</template>

<script setup>
    const props = defineProps({
        home: {
            type: Object,
            required: true,
        },
        maxSlides: {
            type: Number,
            required: false,
            default: -1,
        },
        navigation: {
            type: Boolean,
            default: true,
        },
        showSmallerImages: {
            type: Boolean,
            default: false,
        },
    });

    const slides = computed(() => {
        let imageGallery = [];

        if (props.showSmallerImages && props.home?.image_gallery_small) {
            imageGallery = props.home.image_gallery_small;
        }

        if (!props.showSmallerImages && props.home?.image_gallery) {
            imageGallery = props.home.image_gallery;
        }

        if (props.maxSlides < 1) {
            return imageGallery;
        } else {
            return imageGallery.slice(0, props.maxSlides);
        }
    });

    const containerRef = ref(null);
    const componentId = useId();

    useSwiper(containerRef, {
        pagination: {
            enabled: true,
            clickable: true,
        },
    });
</script>
